export default __webpack_public_path__ + "static/media/d438f8004f433f0b2816eabdb5212515.jpg";